export const MANAGER_APPROVAL = 1;
export const PAYROLL_APPROVAL = 2;
export const CANCEL_APPROVAL = 3;

export const LeaveTaskTypeText = {
  [MANAGER_APPROVAL]: "Manager Approval",
  [PAYROLL_APPROVAL]: "Payroll Approval",
  [CANCEL_APPROVAL]: "Cancel Approval",
};
